import React from 'react';

/**
 * CertLeftImage
 * 
 * Displays the left image for the Certification section.
 */
export const CertLeftImage = () => {
  return (
    <div className="il-add" lower="left" style={{ backgroundImage: `url("/img/cert/cert-left.jpeg")` }}></div>
  );
};
